/* eslint-disable */
import type { GlobalAddress } from "../../common/location.pb";
import type { RequestContext } from "../RequestContextProto.pb";
import type { ResponseContext } from "../ResponseContextProto.pb";
import type { PostalAddress } from "../api/postal_address.pb";

export interface SetAddressRequest {
  request_context?: RequestContext;
  /** The customer's address (which may include just the postal code). */
  postal_address?: GlobalAddress;
  /** List of payment tokens in the current flow. */
  payment_tokens?: string[];
  /** The transfer being acted upon. */
  transfer_token?: string;
  /** True if the address has been validated by (e.g.) Google Places. */
  validated?: boolean;
}

export interface SetAddressResponse {
  response_context?: ResponseContext;
  status?: SetAddressResponseStatus;
  /**
   * A message to display to the customer, typically used when the request failed.
   * Deprecated in v2.18 in favor of ResponseContext.
   *
   * @deprecated
   */
  message?: string;
  /**
   * Echos back the actual address stored by the server. Server might add some address
   * fields e.g. city can be inferred from the postal code provided.
   */
  postal_address?: GlobalAddress;
}

export enum SetAddressResponseStatus {
  INVALID = "INVALID",
  SUCCESS = "SUCCESS",
  CONCURRENT_MODIFICATION = "CONCURRENT_MODIFICATION",
  FAILURE = "FAILURE",
}

export interface VerifyCheckAddressRequest {
  postal_address?: PostalAddress;
}

export interface VerifyCheckAddressResponse {
  status?: VerifyCheckAddressResponseStatus;
  /** A canonical rewrite of the address, as supplied by an external provider. */
  canonical_postal_address?: PostalAddress;
  address_correction_message?: string;
}

export enum VerifyCheckAddressResponseStatus {
  INVALID = "INVALID",
  SUCCESS = "SUCCESS",
}
